import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function Remote(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MYFHE__FHEPRODUCT_SET_REMOTES':
            return core.setRemotes(state, action.remotes);
        case 'MYFHE__FHEPRODUCT_UPDATE_REMOTES':
            return core.updateRemotes(state, action.Remotes);
    }

    return state;
}



// WEBPACK FOOTER //
// ./environments/myfhe/data/Remote/reducer.js